/**
 * Язык интерфейса, если в localStorage ещё нет явного выбора пользователя.
 * Всегда русский; английский включается только через переключатель в профиле (i18n пишет в localStorage).
 */
export const detectInitialLanguage = (): "ru" | "en" => "ru"
